// React
import React from 'react';

// Packages

// Utilities
import { useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';

const Name = CONSTANTS.ACTIVITIES.CBC_ENGAGEMENT;

const Choice = props => {
    return ActivityChoice({
        Name,
        methods: 'Initiative_Activity__c.CBC_Engagement_Method__c',
        fieldName: 'CBC_Engagement_Method__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'CBC_Engagement_Method__c',
                tagTypes: [CONSTANTS.TAGS.ENGAGEMENT_ACTIVITY],
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.ENGAGEMENT_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { CBC_Engagement_Method__c } = formData;

        // Data for sf
        return {
            CBC_Engagement_Method__c,
        };
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        getItemData,
        tagging: tagging.activity,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        primary: true,
        secondary: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        primary: true,
        secondary: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { CBC_Engagement_Method__c } = utilities.activities.get(id);

    // Choice
    form.setValue('CBC_Engagement_Method__c', CBC_Engagement_Method__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
